import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductAlertMessage from "@tCentro/Components/CENProductAlertMessage";
import ProductSpecialMessage from "@tCentro/Components/CENProductSpecialMessage";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface CENProductMessagesStyles {
    wrapper?: InjectableCss;
}

export const cenProductMessagesStyles: CENProductMessagesStyles = {
    wrapper: {
        css: css`
            margin-bottom: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            margin-bottom: 12px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = cenProductMessagesStyles;

const CENProductMessages: React.FC<Props> = ({ product }) => {
    if (!product.properties) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            {product.properties.specialMessage && (
                <ProductSpecialMessage specialMessage={product.properties.specialMessage} />
            )}
            {product.properties.alertMessage && <ProductAlertMessage alertMessage={product.properties.alertMessage} />}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(CENProductMessages),
    definition: {
        displayName: "CEN Product Messages",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
